__turbopack_context__.v({
  "Label": "OT3CUa_Label",
  "Option": "OT3CUa_Option",
  "Options": "OT3CUa_Options",
  "skeleton-loading": "OT3CUa_skeleton-loading",
});
